import ClientDetail from "./ClientDetail";

export default {
    name: 'clients',
    show: ClientDetail
};
